import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from '@material-ui/core';
import defaultStyles from './ToolsListView.module.css';
import jlrStyles from './ToolsListViewJlr.module.css';
import { AuthChecker } from '../../atomicComponents';
import { SVG_ICON_PATHS, TOOLS } from '../../constants';
import clsx from 'clsx';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { setStylesAccordingToPlant } from '../../utils/utils';

const IconMapping = {
  [TOOLS.PRODUCTION_REVIEW]: SVG_ICON_PATHS.graphIcon,
  [TOOLS.ASN_OVERVIEW]: SVG_ICON_PATHS.tvPlayIcon,
  [TOOLS.DROPPING_UPDATE]: SVG_ICON_PATHS.tvPlayIcon,
  [TOOLS.MASTER_DATA_MANAGEMENT]: SVG_ICON_PATHS.toolsIcon,
};

const ToolsListView = ({ listItems = [], handleSelection }) => {
  const [styles, setStyles] = useState(defaultStyles);
  const [plant] = usePlantAndLinesStore().plantState;

  useEffect(() => {
    setStylesAccordingToPlant(plant, setStyles, defaultStyles, jlrStyles);
  }, [plant]);

  return (
    <div className={styles.toolListView}>
      <div className={clsx(styles.scrollContainer, styles.scrollBar)}>
        <span className={styles.toolListTitle}>Tools</span>
        {listItems.map(item => {
          if (item.authOperation)
            return (
              <AuthChecker operation={item.authOperation}>
                {isAuthorized => {
                  return isAuthorized ? (
                    <button
                      key={item.label}
                      type="button"
                      onClick={() =>
                        item.action ? item.action() : handleSelection(item)
                      }
                      className={styles.toolListItem}
                    >
                      <span>{item.label}</span>
                      {IconMapping[item.label] && (
                        <SvgIcon
                          className={styles.imageIcon}
                          viewBox="0 0 36 36"
                        >
                          <path d={IconMapping[item.label]} />
                        </SvgIcon>
                      )}
                      {item.image || null}
                    </button>
                  ) : null;
                }}
              </AuthChecker>
            );
          return (
            <button
              key={item.label}
              type="button"
              onClick={() =>
                item.action ? item.action() : handleSelection(item)
              }
              className={styles.toolListItem}
            >
              <span>{item.label}</span>
              {IconMapping[item.label] && (
                <SvgIcon className={styles.imageIcon} viewBox="0 0 36 36">
                  <path d={IconMapping[item.label]} />
                </SvgIcon>
              )}
              {item.image || null}
            </button>
          );
        })}
      </div>
    </div>
  );
};

ToolsListView.propTypes = {
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      action: PropTypes.func,
    }),
  ),
  handleSelection: PropTypes.func.isRequired,
};
export default ToolsListView;
